module.exports = __webpack_public_path__ + "static/media/EmptyBoxWithClouds.d4041373.svg";